var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { difference, intersection, keys } from 'lodash';
import useForm from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { number, object, string } from 'yup';
import { Button, Divider, Grid, TextField } from '@material-ui/core';
import { enterKeyPress, getPostData, useEmailSignUpFormStyles, } from './EmailSignUpFormTypes';
import { SignUpTerms } from './SignUpTerms';
import { SocialButtonContent } from './SocialButtonContent';
import { useTextFieldErrorStyles, useTextFieldStyles, useTextFieldStylesLOH } from './TextFieldStyles';
import { useAuthFormState } from './useAuthFormState';
import { Loading } from '../Loading/Loading';
import { useEnvironment, useEventListener } from '../../shared/hooks';
export function EmailSignUpForm(props) {
    var _this = this;
    var _a = props.isModal, isModal = _a === void 0 ? true : _a, redirectTo = props.redirectTo, _b = props.showSocialLogins, showSocialLogins = _b === void 0 ? true : _b, team = props.team, _c = props.hideLogin, hideLogin = _c === void 0 ? false : _c, signUpCta = props.signUpCta, _d = props.switchToLoginForm, switchToLoginForm = _d === void 0 ? function () { } : _d, _e = props.isLoggedOutHome, isLoggedOutHome = _e === void 0 ? false : _e, _f = props.showAuth0, showAuth0 = _f === void 0 ? false : _f;
    var classes = useEmailSignUpFormStyles(props);
    var useTextFieldStylesClassesLOH = useTextFieldStylesLOH();
    var useTextFieldStylesClasses = useTextFieldStyles();
    var textFieldClasses = isLoggedOutHome ? useTextFieldStylesClassesLOH : useTextFieldStylesClasses;
    var textFieldErrorClasses = useTextFieldErrorStyles();
    var emailSignUpState = useAuthFormState();
    var appHost = useEnvironment().appHost;
    var _g = __read(useState(''), 2), generalError = _g[0], setGeneralError = _g[1];
    var _h = __read(useState(false), 2), isSubmitting = _h[0], setIsSubmitting = _h[1];
    var intl = useIntl();
    var firstNameMax = intl.formatMessage({
        id: 'authentication.sign-up-form.firstname.max',
        defaultMessage: 'Name fields must be fewer than 50 characters',
        description: 'For a max of characters allowed.',
    });
    var firstNameRequired = intl.formatMessage({
        id: 'authentication.sign-up-form.firstname.required',
        defaultMessage: 'First Name is required',
        description: 'Referring to an input that is required for the user.',
    });
    var lastNameMax = intl.formatMessage({
        id: 'authentication.sign-up-form.lastname.max',
        defaultMessage: 'Name fields must be fewer than 50 characters',
        description: 'For a max of characters allowed.',
    });
    var lastNameRequired = intl.formatMessage({
        id: 'authentication.sign-up-form.lastname.required',
        defaultMessage: 'Last Name is required',
        description: 'Referring to an input that is required for the user.',
    });
    var teamNameRequired = intl.formatMessage({
        id: 'authentication.sign-up-form.teamname.required',
        defaultMessage: 'Company is required',
        description: 'Referring to an input that is required for the user.',
    });
    var emailMin = intl.formatMessage({
        id: 'authentication.sign-up-form.email.min',
        defaultMessage: 'Email field must have at least 5 characters',
        description: 'Minimal value for user input.',
    });
    var emailMax = intl.formatMessage({
        id: 'authentication.sign-up-form.email.max',
        defaultMessage: 'Email field must be fewer than 100 characters',
        description: 'For a max of characters allowed.',
    });
    var emailNotValid = intl.formatMessage({
        id: 'authentication.sign-up-form.email.invalid',
        defaultMessage: 'Email field is not a valid email address.',
        description: 'Referring to an invalid user input.',
    });
    var emailRequired = intl.formatMessage({
        id: 'authentication.sign-up-form.email.required',
        defaultMessage: 'Email is required',
        description: 'Referring to an input that is required for the user.',
    });
    var passwordMin = intl.formatMessage({
        id: 'authentication.sign-up-form.password.min',
        defaultMessage: 'Password field must have at least 8 characters',
        description: 'Minimal value for user input.',
    });
    var passwordMax = intl.formatMessage({
        id: 'authentication.sign-up-form.password.max',
        defaultMessage: 'Password field must be fewer than 64 characters',
        description: 'For a max of characters allowed.',
    });
    var passwordRequired = intl.formatMessage({
        id: 'authentication.sign-up-form.password.required',
        defaultMessage: 'Password is required',
        description: 'Referring to an input that is required for the user.',
    });
    var EmailSignUpFormSchema = object().shape({
        firstName: string().trim().max(50, firstNameMax).required(firstNameRequired),
        lastName: string().trim().max(50, lastNameMax).required(lastNameRequired),
        team: number(),
        teamName: string().when('team', {
            is: 1,
            then: string().required(teamNameRequired),
        }),
        email: string().trim().min(5, emailMin).max(100, emailMax).email(emailNotValid).required(emailRequired),
        password: string().trim().min(8, passwordMin).max(64, passwordMax).required(passwordRequired),
    });
    var _j = useForm({
        mode: 'onSubmit',
        validationSchema: EmailSignUpFormSchema,
    }), register = _j.register, handleSubmit = _j.handleSubmit, errors = _j.errors, setError = _j.setError, clearError = _j.clearError, getValues = _j.getValues, triggerValidation = _j.triggerValidation, setValue = _j.setValue;
    if (team && team.invitation) {
        setValue('email', team.invitation.email);
    }
    var enterKeyHandler = function (event) {
        enterKeyPress({ event: event, validate: triggerValidation, onSubmit: onSubmit });
    };
    useEventListener({ eventName: 'keydown', handler: enterKeyHandler });
    useEffect(function () {
        if (emailSignUpState.recaptcha.recaptchaResponse && emailSignUpState.recaptcha.recaptchaResponse !== '') {
            submitForm();
        }
    }, [emailSignUpState.recaptcha.recaptchaResponse]);
    var recaptchaErrorMsg = intl.formatMessage({
        id: 'authentication.sign-up-form.submit.recaptcha.error',
        defaultMessage: 'Something went wrong. Please try again.',
        description: 'Message that shows up when recaptcha is wrong.',
    });
    var onSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (!emailSignUpState.recaptcha.isRecaptchaLoading && emailSignUpState.recaptcha.recaptchaRef.current) {
                emailSignUpState.recaptcha.executeRecaptcha();
            }
            else {
                setGeneralError(recaptchaErrorMsg);
            }
            return [2];
        });
    }); };
    var submitForm = function () { return __awaiter(_this, void 0, void 0, function () {
        var data, urlParams, urlRedirectTo, postData, landingPageUrl, origin_1, response, error_1;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    data = getValues();
                    urlParams = new URLSearchParams((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.search) !== null && _b !== void 0 ? _b : '');
                    urlRedirectTo = (_c = redirectTo !== null && redirectTo !== void 0 ? redirectTo : urlParams.get('redirectTo')) !== null && _c !== void 0 ? _c : '';
                    postData = getPostData({
                        data: data,
                        recaptchaResponse: emailSignUpState.recaptcha.recaptchaResponse,
                        redirectTo: urlRedirectTo,
                        csrfToken: emailSignUpState.csrfToken,
                        team: team,
                    });
                    if (window.top !== window.self) {
                        landingPageUrl = decodeURIComponent(window.location.href.split('?url=')[1]);
                        postData.append('landing_page_url', landingPageUrl);
                    }
                    setIsSubmitting(true);
                    clearError();
                    setGeneralError('');
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 4]);
                    origin_1 = (_f = (_e = (_d = window === null || window === void 0 ? void 0 : window.location) === null || _d === void 0 ? void 0 : _d.origin) !== null && _e !== void 0 ? _e : appHost) !== null && _f !== void 0 ? _f : '';
                    return [4, emailSignUpState.request.execute({
                            url: origin_1 + "/ajaxsignup",
                            data: postData,
                            method: 'POST',
                        })];
                case 2:
                    response = _g.sent();
                    if (window.top !== window.self) {
                        window.top.location.replace(response.data.redirectTo);
                    }
                    else {
                        window.location.assign(response.data.redirectTo);
                    }
                    return [3, 4];
                case 3:
                    error_1 = _g.sent();
                    handleErrorResponse(error_1);
                    setIsSubmitting(false);
                    return [3, 4];
                case 4: return [2];
            }
        });
    }); };
    var generalErrorMsg = intl.formatMessage({
        id: 'authentication.sign-up-form.submit.general.error',
        defaultMessage: 'Something went wrong. Please try again later',
        description: 'Message that shows up for general purpose.',
    });
    var handleErrorResponse = function (error) {
        if (error.response.status >= 500) {
            setGeneralError(generalErrorMsg);
            return;
        }
        var errors = error.response.data.errors;
        if (typeof errors === 'string') {
            setGeneralError(errors);
            return;
        }
        var inputErrorFields = intersection(EmailSignUpFormSchema._nodes, keys(errors));
        inputErrorFields.forEach(function (field) {
            setError(field, '', errors[field][0]);
        });
        var generalErrorFields = difference(keys(errors), inputErrorFields);
        generalErrorFields.forEach(function (field) {
            setGeneralError(errors[field][0]);
        });
    };
    var onClickLogin = function (event) {
        event.preventDefault();
        if (isModal) {
            switchToLoginForm(true);
            return;
        }
        window.location.pathname = '/login';
    };
    var errorClass = clsx('error', textFieldErrorClasses.root);
    var firstNameMessage = intl.formatMessage({
        id: 'authentication.sign-up-form.textfield.firstname.message',
        defaultMessage: 'First name',
        description: 'Text for label and placeholder of input first name on sign up form.',
    });
    var lastNameMessage = intl.formatMessage({
        id: 'authentication.sign-up-form.textfield.lastname.message',
        defaultMessage: 'Last name',
        description: 'Text for label and placeholder of input lastname on sign up form.',
    });
    var teamNameMessage = intl.formatMessage({
        id: 'authentication.sign-up-form.textfield.teamname.message',
        defaultMessage: 'Company',
        description: 'Text for label and placeholder of input team name on sign up form.',
    });
    var emailMessage = intl.formatMessage({
        id: 'authentication.sign-up-form.textfield.email.message',
        defaultMessage: 'Email address',
        description: 'Text for label and placeholder of input email address on sign up form.',
    });
    var signUpMessage = intl.formatMessage({
        id: 'authentication.sign-up-form.button.text',
        defaultMessage: 'Sign Up',
        description: 'Button to sign up for a Skillshare account.',
    });
    var separatorMessage = intl.formatMessage({
        id: 'authentication.sign-up-form.show-social-logins.separator-message',
        defaultMessage: 'or',
        description: 'Displayed on the sign up section to separate two Sign up options: sign up with email OR sign up with a social media account',
    });
    return (React.createElement("form", { autoComplete: "off" },
        React.createElement(Grid, { container: true, className: classes.grid },
            showSocialLogins && (React.createElement(React.Fragment, null,
                React.createElement(SocialButtonContent, { isSignUp: true, redirectTo: redirectTo, isLoggedOutHome: isLoggedOutHome, showAuth0: showAuth0 }),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement("div", { className: "form-separator " + (isLoggedOutHome ? classes.formSeparator_loh : classes.formSeparator) },
                        React.createElement("p", { "data-testid": "authentication-sign-up-form-show-social-logins-separator-message" }, separatorMessage))))),
            (errors.firstName && (React.createElement("p", { className: errorClass, "data-testid": "authentication-sign-up-form-teamname-required" }, errors.firstName.message))) ||
                (errors.lastName && (React.createElement("p", { className: errorClass, "data-testid": "authentication-sign-up-form-lastname-required" }, errors.lastName.message))) ||
                (generalError && (React.createElement("p", { className: errorClass, "data-testid": "authentication-login-form-submit-general-error" }, generalError))) ||
                (emailSignUpState.recaptcha.recaptchaError && (React.createElement("p", { className: errorClass, "data-testid": "authentication-sign-up-form-submit-recaptcha-error" }, emailSignUpState.recaptcha.recaptchaError))),
            React.createElement(Grid, { container: true, item: true, xs: 12, justify: "space-between", direction: "row", className: classes.FirstLastName_loh },
                React.createElement(TextField, { name: 'firstName', inputRef: register, inputProps: {
                        'aria-label': firstNameMessage,
                    }, placeholder: firstNameMessage, variant: "outlined", classes: textFieldClasses, className: classes.nameField, "data-testid": "authentication-sign-up-form-textfield-firstname-message" }),
                React.createElement(TextField, { name: 'lastName', inputRef: register, inputProps: {
                        'aria-label': lastNameMessage,
                    }, placeholder: lastNameMessage, variant: "outlined", classes: textFieldClasses, className: classes.nameField, "data-testid": "authentication-sign-up-form-textfield-lastname-message" })),
            team && team.isSignUp && (React.createElement(React.Fragment, null,
                errors.teamName && (React.createElement("p", { className: errorClass, "data-testid": "authentication-sign-up-form-teamname-required" }, errors.teamName.message)),
                React.createElement(Grid, { item: true, xs: 12 },
                    React.createElement(TextField, { name: 'teamName', inputRef: register, inputProps: {
                            'aria-label': teamNameMessage,
                        }, placeholder: teamNameMessage, variant: "outlined", classes: textFieldClasses, "data-testid": "authentication-sign-up-form-textfield-teamname-message" })),
                React.createElement(TextField, { name: 'team', type: 'hidden', value: 1, inputRef: register }))),
            errors.email && (React.createElement("p", { className: errorClass, "data-testid": "authentication-sign-up-form-email-required" }, errors.email.message)),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(TextField, { name: 'email', type: 'email', inputRef: register, inputProps: {
                        'aria-label': emailMessage,
                        className: team && team.invitation ? 'bold' : 'normal',
                        readOnly: team && team.invitation ? true : false,
                    }, placeholder: emailMessage, variant: "outlined", classes: textFieldClasses, className: 'bold', "data-testid": "authentication-sign-up-form-textfield-email-message" })),
            errors.password && (React.createElement("p", { className: errorClass, "data-testid": "authentication-sign-up-form-password-required" }, errors.password.message)),
            React.createElement(Grid, { item: true, xs: 12, className: classes.passwordSpacing },
                React.createElement(TextField, { inputRef: register, name: 'password', type: 'password', inputProps: {
                        'aria-label': intl.formatMessage({
                            id: 'authentication.sign-up-form.textfield.password.arial-label',
                            defaultMessage: 'Password',
                            description: 'Text for label on sign up form.',
                        }),
                    }, placeholder: intl.formatMessage({
                        id: 'authentication.sign-up-form.textfield.password.placeholder',
                        defaultMessage: 'Create password',
                        description: 'Text for placeholder on sign up form.',
                    }), variant: "outlined", classes: textFieldClasses, "data-testid": "authentication-sign-up-form-textfield-password-placeholder" })),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement("p", { className: isLoggedOutHome ? classes.passwordRequirement_loh : classes.passwordRequirement },
                    React.createElement(FormattedMessage, { id: "authentication.sign-up-form.password.error-message", defaultMessage: "Password must be at least 8 characters long.", description: "Text that shows up a warning when validating password input." }))),
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Button, { onClick: handleSubmit(onSubmit), variant: "contained", color: "primary", disableElevation: true, className: clsx('submit-btn', classes.submitBtn), disabled: isSubmitting, "data-cy": "signup-embedded-btn", "data-testid": "authentication-sign-up-form-button" }, isSubmitting ? (React.createElement(Loading, { size: 39, fillColor: '#FFF' })) : team && (team.isSignUp || team.isInvitation) ? (team.submitText) : (signUpCta !== null && signUpCta !== void 0 ? signUpCta : signUpMessage))),
            !team && (React.createElement(React.Fragment, null,
                !hideLogin && (React.createElement(React.Fragment, null,
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement("div", { className: isLoggedOutHome ? classes.member_loh : classes.member },
                            React.createElement(FormattedMessage, { "data-testid": "authentication-sign-up-form-registered-member-text", id: "authentication.sign-up-form.registered-member.text", defaultMessage: "Already a member?", description: "Text for asking to the user if is already a member." }),
                            React.createElement("button", { className: "link", onClick: onClickLogin },
                                React.createElement(FormattedMessage, { "data-testid": "authentication-sign-up-form-signin-text", id: "authentication.sign-up-form.signin.text", defaultMessage: "Sign In", description: "Text for the user to sign in." })))),
                    React.createElement(Grid, { item: true, xs: 12, className: isLoggedOutHome ? classes.separator_loh : classes.separator },
                        React.createElement(Divider, null)))),
                React.createElement(Grid, { className: classes.terms, item: true, xs: 12 },
                    React.createElement(SignUpTerms, { isLoggedOutHome: isLoggedOutHome })))),
            React.createElement("div", { ref: emailSignUpState.recaptcha.recaptchaRef, className: "grecaptcha" }))));
}
//# sourceMappingURL=EmailSignUpForm.js.map